import React from "react";
import { Table } from "reactstrap";
import PropTypes from "prop-types";

import WatchListEntryTableRow from "./watch-list-entry-table-row";
import { watchListEntryType } from "../../../../prop-types";

const WatchListEntriesTable = ({
  canEdit,
  watchListEntries,
  hidePercent,
  ...rest
}) => {
  const rows = watchListEntries.map((entry, i) => (
    <WatchListEntryTableRow
      {...rest}
      hidePercent={hidePercent}
      canEdit={canEdit}
      key={`${entry.id}-${i}`}
      watchListEntry={entry}
    />
  ));

  return (
    <div className="table-overflow-container">
      <Table className="watch-list-entries-table">
        <thead className="thead-light">
          <tr>
            <th scope="col"></th>
            <th scope="col">Category</th>
            <th scope="col">Watchlist</th>
            {!hidePercent ? <th scope="col">Match %</th> : null}
            <th scope="col">Full Name</th>
            <th scope="col">First Name</th>
            <th scope="col">Middle Name</th>
            <th scope="col">Last Name</th>
            <th scope="col">Date of Birth/Est.</th>
            <th scope="col">Nationality</th>
            <th scope="col">EGN_UCN</th>
            <th scope="col" className="center">
              Actions
            </th>
            <th scope="col"></th>
          </tr>
        </thead>
        <tbody>{rows}</tbody>
      </Table>
    </div>
  );
};

WatchListEntriesTable.propTypes = {
  watchListEntries: PropTypes.arrayOf(watchListEntryType).isRequired,
};

export default WatchListEntriesTable;



// WEBPACK FOOTER //
// ./src/features/watch-list-entry/components/watch-list-entries-table/WatchListEntriesTable.jsx